/** Các bước cố định của luồng chatbot tạo yêu cầu chức năng. */
export type StepKey =
  | 'SELECT_SERVICE'
  | 'CHOOSE_MODE'
  | 'AI_CONVERSE'
  | 'ASK_TITLE'
  | 'ASK_DESCRIPTION'
  | 'SELECT_PROJECT'
  | 'SELECT_PHASE'
  | 'ASK_IMAGES'
  | 'CONFIRM'
  | 'DONE';

/** Danh sách runtime của StepKey — dùng để validate dữ liệu đọc từ bên ngoài (ví dụ localStorage). */
export const STEP_KEYS: StepKey[] = [
  'SELECT_SERVICE',
  'CHOOSE_MODE',
  'AI_CONVERSE',
  'ASK_TITLE',
  'ASK_DESCRIPTION',
  'SELECT_PROJECT',
  'SELECT_PHASE',
  'ASK_IMAGES',
  'CONFIRM',
  'DONE',
];

export function isStepKey(value: unknown): value is StepKey {
  return typeof value === 'string' && STEP_KEYS.includes(value as StepKey);
}

/** Một lượt trong hội thoại AI — khớp `ConverseTurn` ở `types/index.ts`, định nghĩa lại ở đây để module này không phụ thuộc ngược vào `api/`. */
export interface AiTurn {
  role: 'user' | 'bot';
  text: string;
}

export interface ChatDraft {
  service: string | null;
  /** Chế độ user chọn ở bước CHOOSE_MODE — null trước khi chọn. */
  mode: 'ai' | 'steps' | null;
  aiTurns: AiTurn[];
  aiTurnsUsed: number;
  rawTitle: string;
  refinedTitle: string | null;
  rawDescription: string;
  refinedDescription: string | null;
  projectId: string | null;
  phaseId: string | null;
  images: File[];
}

export function createEmptyDraft(): ChatDraft {
  return {
    service: null,
    mode: null,
    aiTurns: [],
    aiTurnsUsed: 0,
    rawTitle: '',
    refinedTitle: null,
    rawDescription: '',
    refinedDescription: null,
    projectId: null,
    phaseId: null,
    images: [],
  };
}
